import { FileDownloadOutlined, OpenInNewOutlined, VisibilityOutlined } from "@mui/icons-material";
import { Grid, Stack, Tooltip, Typography, useTheme } from "@mui/material";
import { ChatButton } from "Common/Components";
import { PDFColored } from "Icons/Icons";

interface IReferenceListItem {
  onClick?: () => void;
  title?: string;
  description?: string;
  fileLink?: string;
  fileName: string;
  fileType: string;
}

export const ReferenceListItem = (props: IReferenceListItem) => {
  const { onClick, title, description, fileLink, fileName, fileType } = props;
  const theme = useTheme();
  const handleOpeninNew = () => {
    if (fileLink) {
      window.open(fileLink, "_blank");
    }
  };
  const handleDownload = () => {
    if (fileLink) {
      fetch(fileLink) // Ensure CORS is allowed
        .then((response) => {
          if (response.ok) {
            return response.blob(); // Convert to blob for download
          }
          throw new Error("File could not be downloaded");
        })
        .then((blob) => {
          const url = window.URL.createObjectURL(blob);
          const link = document.createElement("a");
          link.href = url;
          link.download = fileName + "." + fileType; // Set a default filename
          document.body.appendChild(link);
          link.click();
          link.remove();
          window.URL.revokeObjectURL(url); // Clean up URL object
        })
        .catch((error) => console.error("Download error:", error));
    }
  };

  return (
    <Grid
      container
      sx={(theme) => ({
        paddingY: 1,
        px: 2,
        borderBottom: `1px solid ${theme.palette.divider}`,
        justifyContent: "space-between",
      })}
    >
      <Grid sx={{ xs: 10 }}>
        <Stack sx={{ display: "flex" }} direction={"row"} spacing={2.5}>
          <PDFColored />
          <span>
            <Tooltip title={title}>
              <Typography
                sx={{
                  color: theme.palette.grey[800],
                  fontWeight: "semiBold",
                  wordWrap: "break-word", // Ensures the text wraps
                  whiteSpace: "normal", // Allow wrapping
                  overflow: "hidden", // Avoid overflow issues
                  textOverflow: "ellipsis", // If you want to show ellipsis for long text
                }}
              >
                {title}
              </Typography>
            </Tooltip>
          </span>
        </Stack>
        <Typography
          sx={{
            color: theme.palette.grey[600],
            wordWrap: "break-word", // Ensure text wraps for the description
            whiteSpace: "normal", // Allow wrapping
          }}
        >
          {description}
        </Typography>
      </Grid>

      <Grid sx={{ xs: 2 }}>
        <Stack
          direction={"row"}
          sx={{
            flexDirection: "row",
            display: "flex",
            alignItems: "center",
            justifyContent: "flex-end",
            mt: 1,
          }}
          spacing={1}
        >
          <ChatButton
            tooltipTitle="View Document"
            hasBackground
            backgroundColor={theme.palette.grey[100]}
            Icon={VisibilityOutlined}
            onClick={onClick}
          />
          <ChatButton
            tooltipTitle="Download Document"
            hasBackground
            backgroundColor={theme.palette.grey[100]}
            Icon={FileDownloadOutlined}
            onClick={handleDownload}
          />
          <ChatButton
            tooltipTitle="Open With Default Browser"
            hasBackground
            backgroundColor={theme.palette.grey[100]}
            Icon={OpenInNewOutlined}
            onClick={handleOpeninNew}
          />
        </Stack>
      </Grid>
    </Grid>
  );
};
